// propertiesData.js

export const propertiesData = [
  {
    id: 1,
    name: "Hinton Ho use",
    category: "Residential",
    status: "Rent",
    location: "Witbank",
    beds: 3,
    baths: 2,
    sqft: 1200,
    price: "R15,000 / month",
    agentName: "Steve Parker",
    agentPhone: "+27 11 234 5678",
    agentEmail: "steve.parker@raulfex.com",
    image: "https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80"
    ],
    description: "Spacious family home with a large backyard, modern kitchen, and secure neighborhood access.",
    features: {
      wifi: true,
      electricity: true,
      water: true,
      parking: 2,
      garden: true,
      security: true,
      petFriendly: true
    },
    yearBuilt: 2016,
    address: "Industrial Park Road, Witbank"
  },
  {
    id: 2,
    name: "EIRAX House",
    category: "Residential",
    status: "Sale",
    location: "Johannesburg",
    beds: 4,
    baths: 3,
    sqft: 1800,
    price: "R2,850,000",
    agentName: "Linda Khumalo",
    agentPhone: "+27 11 876 4455",
    agentEmail: "linda.khumalo@raulfex.com",
    image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2148",
    images: [
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2148",
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80"
    ],
    description: "Modern double-story home with pool, solar power, and top-tier security system.",
    features: {
      wifi: true,
      electricity: true,
      water: true,
      parking: 2,
      garden: true,
      pool: true,
      security: true
    },
    yearBuilt: 2019,
    address: "45 Canterbury Crescent, Johannesburg"
  },
  {
    id: 3,
    name: "The Arc Towers",
    category: "Commercial",
    status: "Rent",
    location: "Pretoria",
    beds: 0,
    baths: 2,
    sqft: 3000,
    price: "R48,000 / month",
    agentName: "Siyabonga Nkosi",
    agentPhone: "+27 12 345 6789",
    agentEmail: "siyabonga.nkosi@raulfex.com",
    image: "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=800&q=80"
    ],
    description: "Premium office suites located in the Pretoria business district, with generator backup and parking.",
    features: {
      wifi: true,
      electricity: true,
      water: true,
      parking: 8,
      security: true,
      furnished: false
    },
    yearBuilt: 2018,
    address: "7 Justice Mahomed Street, Pretoria"
  },
  {
    id: 4,
    name: "Palm View Apartments",
    category: "Residential",
    status: "Rent",
    location: "Durban",
    beds: 2,
    baths: 1,
    sqft: 900,
    price: "R10,500 / month",
    agentName: "Fatima Ismail",
    agentPhone: "+27 31 456 7788",
    agentEmail: "fatima.ismail@raulfex.com",
    image: "https://images.unsplash.com/photo-1574597935791-86231e59e6a4?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2344",
    images: [
      "https://images.unsplash.com/photo-1574597935791-86231e59e6a4?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2344",
      "https://images.unsplash.com/photo-1584498450649-a7b0b6a6692c?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1964",
      "https://images.unsplash.com/photo-1599076695486-60d66fcb2ac8?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1556"
    ],
    description: "Beachside living at its best. 2-bedroom apartment with ocean views and 24-hour security.",
    features: {
      wifi: true,
      electricity: true,
      water: true,
      parking: 1,
      security: true,
      furnished: true
    },
    yearBuilt: 2020,
    address: "9 Marine Parade, Durban"
  },
  {
    id: 5,
    name: "Polokwane Business Centre",
    category: "Commercial",
    status: "Sale",
    location: "Polokwane",
    beds: 0,
    baths: 3,
    sqft: 5000,
    price: "R5,600,000",
    agentName: "George Phiri",
    agentPhone: "+27 15 234 0099",
    agentEmail: "george.phiri@raulfex.com",
    image: "https://images.unsplash.com/photo-1595980542930-9eea66620834?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2274",
    images: [
      "https://images.unsplash.com/photo-1595980542930-9eea66620834?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2274",
      "https://images.unsplash.com/photo-1624800873328-129498d2847a?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2340",
      "https://images.unsplash.com/photo-1476411942481-0ba7fb479d9c?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2338"
    ],
    description: "Office block located in central Polokwane with multiple tenants and secure parking.",
    features: {
      electricity: true,
      water: true,
      wifi: true,
      parking: 10,
      security: true
    },
    yearBuilt: 2015,
    address: "34 Grobler Street, Polokwane"
  },
  {
    id: 6,
    name: "Cape Point Villa",
    category: "Residential",
    status: "Sale",
    location: "Cape Town",
    beds: 5,
    baths: 4,
    sqft: 2400,
    price: "R6,500,000",
    agentName: "Rebecca Naidoo",
    agentPhone: "+27 21 556 9911",
    agentEmail: "rebecca.naidoo@raulfex.com",
    image: "https://images.unsplash.com/photo-1664362657309-7dd53ca62b7e?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2162",
    images: [
      "https://images.unsplash.com/photo-1657690230097-8a538d642a60?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2148",
      "https://images.unsplash.com/photo-1655231672831-f5cc2f559063?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2340",
      "https://images.unsplash.com/photo-1657690230097-8a538d642a60?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2106"
    ],
    description: "Luxury villa with ocean views, infinity pool, and modern architectural design in Camps Bay.",
    features: {
      wifi: true,
      electricity: true,
      water: true,
      pool: true,
      parking: 3,
      garden: true,
      security: true
    },
    yearBuilt: 2021,
    address: "21 Geneva Drive, Camps Bay, Cape Town"
  },
  {
    id: 7,
    name: "Mpumalanga Farm Estate",
    category: "Residential",
    status: "Sale",
    location: "Mpumalanga",
    beds: 6,
    baths: 3,
    sqft: 3500,
    price: "R3,800,000",
    agentName: "David Van Wyk",
    agentPhone: "+27 13 345 6678",
    agentEmail: "david.vanwyk@raulfex.com",
    image: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80",
    images: [
      "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=800&q=80"
    ],
    description: "Beautiful countryside estate surrounded by greenery, featuring barns and solar panels.",
    features: {
      wifi: false,
      electricity: true,
      water: true,
      parking: 4,
      garden: true,
      security: true
    },
    yearBuilt: 2012,
    address: "Plot 18, Nelspruit District, Mpumalanga"
  },
  {
    id: 8,
    name: "Soweto Townhouse",
    category: "Residential",
    status: "Rent",
    location: "Soweto",
    beds: 2,
    baths: 1,
    sqft: 800,
    price: "R7,500 / month",
    agentName: "Bongiwe Dube",
    agentPhone: "+27 81 222 7789",
    agentEmail: "bongiwe.dube@raulfex.com",
    image: "https://images.unsplash.com/photo-1430285561322-7808604715df?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2340",
    images: [
      "https://images.unsplash.com/photo-1633355289074-bec9b27c8ff9?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2340",
      "https://images.unsplash.com/photo-1619103679013-5d489f7c9104?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=1935",
      "https://images.unsplash.com/photo-1755100840317-03e90a62ff30?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2352"
    ],
    description: "Comfortable townhouse with a modern design, perfect for small families or couples.",
    features: {
      wifi: true,
      electricity: true,
      water: true,
      parking: 1,
      garden: true,
      security: true
    },
    yearBuilt: 2018,
    address: "112 Vilakazi Street, Soweto"
  },
  {
    id: 9,
    name: "Midrand Logistics Hub",
    category: "Industrial",
    status: "Rent",
    location: "Midrand",
    beds: 0,
    baths: 2,
    sqft: 10000,
    price: "R85,000 / month",
    agentName: "Paul Jacobs",
    agentPhone: "+27 11 675 1234",
    agentEmail: "paul.jacobs@raulfex.com",
    image: "https://images.unsplash.com/photo-1759272548470-d0686d071036?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2340",
    images: [
      "https://images.unsplash.com/photo-1759272548470-d0686d071036?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2340",
      "https://images.unsplash.com/photo-1759216373582-a24c4a65b031?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2340",
      "https://images.unsplash.com/photo-1759389003674-bbc78848a532?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2532"
    ],
    description: "High-security warehouse with office space, truck access, and fiber internet.",
    features: {
      electricity: true,
      parking: 12,
      security: true,
      wifi: true
    },
    yearBuilt: 2020,
    address: "Plot 12, Old Pretoria Road, Midrand"
  },
  {
    id: 10,
    name: "Centurion Golf Estate Home",
    category: "Residential",
    status: "Sale",
    location: "Centurion",
    beds: 4,
    baths: 3,
    sqft: 2100,
    price: "R3,200,000",
    agentName: "Tanya De Beer",
    agentPhone: "+27 12 777 8899",
    agentEmail: "tanya.debeer@raulfex.com",
    image: "https://images.unsplash.com/photo-1717167398870-510c1c99cafe?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2532",
    images: [
      "https://images.unsplash.com/photo-1717167398870-510c1c99cafe?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2532",
      "https://images.unsplash.com/photo-1717167398830-05e70ed34b67?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2532",
      "https://images.unsplash.com/photo-1623241347912-cc1acd0da927?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&q=80&w=2340"
    ],
    description: "Elegant home within the Centurion Golf Estate featuring modern finishes and golf course views.",
    features: {
      wifi: true,
      electricity: true,
      water: true,
      parking: 2,
      garden: true,
      security: true,
      furnished: false
    },
    yearBuilt: 2017,
    address: "88 Fairway Drive, Centurion"
  }
];


// Helper functions

// Get property by ID
export const getPropertyById = (id) => {
  return propertiesData.find((p) => p.id === parseInt(id));
};

// Get unique locations (for filters)
export const getUniqueLocations = () => {
  const locations = propertiesData.map((p) => p.location);
  return ['All', ...new Set(locations)];
};